import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {TemplateNode} from "#template/template-node/template-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import {R1Variable} from "#template/nodes/variable/r1-variable"

export type TranslationParameters = {
    x: number | R1Variable
    y: number | R1Variable
    z: number | R1Variable
}

const translationDefinition: TemplateNodeDefinition<TranslationParameters> = {
    nodeClass: "Translation",
    validation: {
        parameters: z.object({
            x: z.union([z.number(), graphNode(R1Variable)]),
            y: z.union([z.number(), graphNode(R1Variable)]),
            z: z.union([z.number(), graphNode(R1Variable)]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class Translation extends TemplateNode<TranslationParameters> {
    public override get definition() {
        return translationDefinition
    }
}
